import { Button, Modal, Tooltip, useLocalization } from '@magicdoorinc/ui';
import { createEffect, createMemo, createSignal } from 'solid-js';
import BgImg from '~/assets/images/referral/bg.png';
import GiftBoxImg from '~/assets/images/referral/giftBox.png';
import { createClipboard } from '~/utils/clipboard';
import type { Component } from 'solid-js';
export const ReferralModal: Component<{
  url: string;
  open: boolean;
  onClose: () => void;
}> = (props) => {
  const { t } = useLocalization();

  const [beforeText, setBeforeText] = createSignal<string>();
  const [afterText, setAfterText] = createSignal<string>();
  const amount = '$500';
  const textWithMarker = createMemo(() => t('referral.modal.reward', { amount: '%%AMOUNT%%' }));
  createEffect(() => {
    const [before, after] = textWithMarker().split('%%AMOUNT%%');
    setBeforeText(before);
    setAfterText(after);
  });

  const { copy, tooltipMessage } = createClipboard({
    errorMessage: t('Failed to copy'),
    tooltipMessages: {
      default: t('Click to copy'),
      copied: t('Copied!'),
    },
  });

  return (
    <Modal
      class="max-w-screen-sm"
      showCloseButton={true}
      footer={
        <div class="mx-auto flex w-11/12 items-center gap-2 border-t border-[#0000001F] py-5">
          <span class="text-wrap text-xs text-text-02">{t('We value your feedback and invite you to leave a review.')}</span>
          <a
            class="text-nowrap rounded-full border border-primary px-2.5 py-1 text-xs text-primary"
            target="_blank"
            href="https://www.trustpilot.com/evaluate/www.magicdoor.com">
            {t('Submit for a review')}
          </a>
        </div>
      }
      onCancel={props.onClose}
      title={t('Invitation')}
      visible={props.open}>
      <div class="mb-2">
        <div
          class="flex h-[143px] w-full items-center justify-between gap-4 bg-cover bg-left bg-no-repeat px-4 md:px-8"
          style={{
            'background-image': `url(${BgImg})`,
          }}>
          <img class="w-[160px] md:w-[210px]" src={GiftBoxImg} alt="GiftBoxImg" />
          <div class="max-w-[329px] flex-1 text-base font-medium text-white md:text-2xl">
            {beforeText()}
            <span class="text-2xl font-semibold text-[#F8FF1F] md:text-3xl">{amount}</span>
            {afterText()}
          </div>
        </div>
        <div class="mx-auto mt-5 flex w-11/12 flex-col gap-3">
          <div class="text-base font-semibold text-text-02">{t('Share link')}</div>
          <div class="text-xs text-text-02">
            {t('Copy the link and send it to your friends. When your friends click on the link to register, they will receive a reward.')}
          </div>
          <div class="flex items-center justify-between rounded-lg bg-separator px-1.5 py-1">
            <span class="flex-1 truncate text-sm text-primary">{props.url}</span>
            <Tooltip message={tooltipMessage()} class="cursor-pointer" align="top">
              <Button onClick={() => copy(props.url)}>{t('Copy')}</Button>
            </Tooltip>
          </div>
        </div>
      </div>
    </Modal>
  );
};
